import React from "react";
import SkillsBar from "./SkillsBar";

const HireAs = () => {
  return (
    <div className="grid gap-7 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-8 mb-4 ">
      <div>
        <h1 className="text-xl font-bold text-gray-500">What is My Process?</h1>
        <p className="font-serif">
          Duis mollis, est non commodo luctus, nisi porttitor ligula, eget
          lacinia odio sem nec elit. Aenean eu leo quam. Pellentesque ornare sem
          lacinia quam. Sed posuere consectetur est at lobortis fusce dapibus.
        </p>
        <ol className="list-decimal mt-4 ms-3 font-serif text-gray-600">
          <li> Vivamus sagittis lacus vel augue laoreet.</li>
          <li> Cras mattis consectetur purus sit amet.</li>
          <li> Vestibulum id ligula porta felis euismod.</li>
          <li> Nulla vitae elit libero, a pharetra augue.</li>
        </ol>
      </div>
      <div>
        <h1 className="text-xl font-bold text-gray-500"> Why Choose Me?</h1>
        <p className="font-serif">
          Vestibulum id ligula porta felis euismod semper. Cras mattis
          consectetur purus sit amet fermentum. Donec ullamcorper nulla non
          metus auctor fringilla. Nullam quis risus eget urna mollis ornare vel
          eu leo.
        </p>
        <ol className="list-disc mt-4 ms-3 font-serif text-gray-600">
          <li> Donec ullamcorper nulla non metus auctor.</li>
          <li> Cras justo odio, dapibus ac facilisis.</li>
          <li> Praesent commodo cursus magna.</li>
          <li> Curabitur blandit tempus porttitor.</li>
        </ol>
      </div>
      <div>
        <SkillsBar />
      </div>
    </div>
  );
};

export default HireAs;
